import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { withStyles } from "@material-ui/core";
import { Cookies } from "react-cookie";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import JDate from "jalali-date";
import Switch from "@material-ui/core/Switch";
import Snackbar from "@material-ui/core/Snackbar";
import * as constants from "../constants";
import Divider from "@material-ui/core/Divider";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Moment from "moment";
import NumberFormat from "react-number-format";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import Calendar from "react-modern-calendar-datepicker";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FloatingLabelInput from "./FloatingLabelInput";
import Fab from "@material-ui/core/Fab";
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import Select from "react-select";
import ImageUploader from "react-images-upload";
import { Multiselect } from "multiselect-react-dropdown";
import ReactExport from "react-data-export";
import { $POST } from "./../func";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const styleselect = {
  multiselectContainer: {
    // To change css for multiselect (Width,height,etc..)
    fontSize: "14px",
    border: "1.25px solid #bababa",
    borderRadius: "4px",
    marginTop: "15px",
  },
  searchBox: {
    // To change search box element look
    fontSize: "14px",
    minheight: "50px",
    textAlign: "right",
    padding: " 10px",
  },
  inputField: {
    // To change input field position or margin
    margin: "5px",
    fontSize: "14px",
  },
  chips: {
    // To change css chips(Selected options)
    //  background: '#00000000',
    border: "2px solid",
    fontSize: "14px",
  },
  optionContainer: {
    // To change css for option container
    textAlign: "right",
  },
  option: {
    // To change css for dropdown options
    fontSize: "14px",
    textAlign: "right",
  },
  groupHeading: {
    // To chanage group heading style
  },
};

const styles = (theme) => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(20),
    },
  },
  root: {
    width: "100%",
    margin: "15px",
    padding: "8px",
    direction: "rtl",
  },
  container: {
    maxHeight: 400,
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
});

class ChangeKindsendrequest extends Component {
  cookies = new Cookies();
  temp333;
  constructor(props) {
    super(props);
    this.multiselectCompanyRef = React.createRef();
    this.multiselectFieldinsuranceRef = React.createRef();
    this.multiselectSendrequestKindRef = React.createRef();
    this.multiselectStateRef = React.createRef();
    this.multiselectCityRef = React.createRef();

    this.state = {
      redirect: false,
      errstr: "",
      errstatus: false,
      okstatus: false,
      requestinfos: [],
      agentInfofilter: [],
      rowsPerPage: 5,
      page: 0,
      kindsendrequest_id: "",
      agent_code: "",
      agent_name: "",
      agent_family: "",
      agent_mobile: "",
      agent_tell: "",
      agent_company_name: "",
      agent_city_name: "",
      agent_company_logo_url: "",
      fieldinsurance_name: "",
      fieldinsurance_logo_url: "",
      orderBy: "kindsendrequest_id",
      order: "desc",
      snackstr: "",
      showSnack: false,
      snackMode: "success",
      newKindsendrequest: true,

      optionAgent: [],
      selectedAgent: "",

      optionCompany: [],
      optionShift: [],
      optionFilterCompany: "",
      selectedCompany: { value: "0", label: "" },
      selectedShift: { value: "0", label: "" },

      optionFieldinsurance: [{ value: "0", label: "همه رشته ها" }],
      optionFilterFieldinsurance: "",
      selectedFieldinsurance: { value: "0", label: "همه رشته ها" },

      optionSendrequestKind: [],
      optionFilterSendrequestKind: "",
      selectedSendrequestKind: "",

      optionState: [{ value: "0", label: "همه استانها" }],
      selectedState: { value: "0", label: "همه استانها" },
      optionCity: [{ value: "0", label: "همه شهرها" }],
      optionFilterCity: [],
      selectedCity: { value: "0", label: "همه شهرها" },

      selectedFilterCompany: [],
      selectedFilterSendrequestKind: [],
      selectedFilterFieldinsurance: [],
      selectedFilterState: [],
      selectedFilterCity: [],
      selectedFilterDeactive: "",
    };
  }

  handleClickcloseTasckBar = (event) => {
    this.setState({ showSnack: false });
  };

  handleSelectRows = (row2) => {
    console.log(row2);

    let selectedCompany;
    if (!row2.agent_company_name || !row2.company_id) {
      // یعنی یا null یا "" بود
      selectedCompany = { value: "0", label: "همه شرکت‌ها", logo: null };
    } else {
      selectedCompany = {
        value: row2.company_id,
        label: row2.agent_company_name,
        logo: row2.agent_company_logo_url,
      };
    }

    this.setState(
        {
          kindsendrequest_id: row2.kindsendrequest_id,
          newKindsendrequest: false,
          selectedCompany: selectedCompany,
          selectedShift: {
            value: row2.shift_id,
            label: row2.shift_name,
          },
          selectedFieldinsurance: {
            value: row2.kindsendrequest_fieldinsurance_id,
            label: row2.fieldinsurance_name,
            logo: row2.fieldinsurance_logo_url,
          },
          selectedSendrequestKind: {
            value: row2.kindsendrequest_kind_id,
            label: row2.sendrequest_kind_name,
          },
          selectedState: {
            value: row2.kindsendrequest_state_id,
            label: row2.agent_state_name,
          },
          selectedCity: {
            value: row2.kindsendrequest_city_id,
            label: row2.agent_city_name,
          },
          selectedAgent: {
            value: row2.kindsendrequest_agent_id,
            label:
                row2.agent_name + " " + row2.agent_family + "-" + row2.agent_mobile,
            agent_status: row2.agent_status,
            company_id: row2.company_id,
          },
        },
        () => {
          this.getoptionCityID();
        }
    );
  };

  newKindsendrequestFunc = (event) => {
    this.setState({
      kindsendrequest_id: "",
      newKindsendrequest: true,
      selectedCompany: { value: "0", label: "" },
      selectedShift: { value: "0", label: "" },
      selectedFieldinsurance: [{ value: "0", label: "همه شرکت ها" }],
      selectedSendrequestKind: {},
      selectedState: { value: "0", label: "همه استانها" },
      selectedCity: { value: "0", label: "همه شهرها" },
    });
  };
//   ---------------------------------------------------------------------------------------------------------
async  componentDidMount() {
    if (this.cookies.get("employee_token_str")) {
      this.props.props.props.dispatch({
        type: "WAITSHOW",
      });

      var self = this;
      const response = await $POST("employeelogin?command=checkemployeelogin");
      const arr = response.data;
        if (response.status == 200) {
          if (arr.result === "ok") {
            self.getKindsendrequest();
            self.getoptionStateID();
            self.getoptionCompany();
            self.getoptionShift();
            self.getoptionFieldinsurance();
            self.getoptionSendrequestKind();
            self.getoptionAgent();
          } else if (arr.result === "error") {
            self.setState({ redirect: true });
          }
          self.props.props.props.dispatch({
            type: "WITEHIDE",
          });
        }
   
    } else {
      this.setState({ redirect: true });
    }
  }


// -----------------------------------------------------------------------------------------------

async  getKindsendrequest() {
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });
    var self = this;
    const response = await $POST("kindsendrequest?command=get_kindsendrequest");
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          self.setState(
            { requestinfos: arr.data, agentInfofilter: arr.data },
            () => {}
          );
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        } else if (arr.result === "eror") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
  
  }


// -------------------------------------------------------------------------------------------------------

async  getoptionCompany () {
    var self = this;
    const response = await $POST("company?command=get_company");
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          var Company = [];
          for (var k = 0; k < arr.data.length; k++) {
            Company.push({
              value: arr.data[k].company_id,
              label: arr.data[k].company_name,
              logo: arr.data[k].company_logo_url,
            });
          }
          Company.unshift({
            value: "0",
            label: "همه شرکت‌ها",
            logo: null,
          });
          self.setState({ optionCompany: Company }, () => {});
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
  }
  async  getoptionShift () {
    var self = this;
    const response = await $POST("agent?command=get_shift");
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          var Shift = [];
          for (var k = 0; k < arr.data.length; k++) {
            Shift.push({
              value: arr.data[k].id,
              label: arr.data[k].name,
            });
          }
          self.setState({ optionShift: Shift }, () => {});
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
  };


// ----------------------------------------------------------------------------------------------


async   getoptionFieldinsurance ()  {
      //   post
    var self = this;
    const response = await $POST("fieldinsurance?command=get_fieldinsurance");
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          var Fieldinsurance = [{ value: "0", label: "همه رشته ها" }];
          for (var k = 0; k < arr.data.length; k++) {
            Fieldinsurance.push({
              value: arr.data[k].fieldinsurance_id,
              label: arr.data[k].fieldinsurance_fa,
              logo: arr.data[k].fieldinsurance_logo_url,
            });
          }
          self.setState({ optionFieldinsurance: Fieldinsurance }, () => {});
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
  };





  getoptionAgent () {

    const { selectedCompany } = this.state;

    console.log("aloooo",selectedCompany)

    var self = this;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var arr = JSON.parse(this.responseText);
        if (arr.result === "ok") {
          var State = [];
          for (var k = 0; k < arr.data.length; k++) {
            State.push({
              value: arr.data[k].agent_id,
              label:
                arr.data[k].agent_name +
                " " +
                arr.data[k].agent_family +
                "-" +
                arr.data[k].agent_mobile,
              agent_status: arr.data[k].agent_status,
              company_id: arr.data[k].company_id,
            });
          }
          self.setState({ optionAgent: State });
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
    };
    var fd = new FormData();
    fd.append("command", "get_agent");
    // if (selectedCompany.value != "0") {
      console.log(selectedCompany );
      fd.append("agent_company_id", selectedCompany.value);

    // } //

    xhttp.open("POST", `${constants.BASE_URL}/agent`);
    xhttp.setRequestHeader(
      "Authorization",
      this.cookies.get("employee_token_str")
    );
    xhttp.send(fd);
  };



// -------------------------------------------------------------------------------------------------------
 async getoptionSendrequestKind () {
    var self = this;
    const response = await $POST("kindsendrequest?command=get_sendrequest_kind");
    const arr = response.data;
      if (response.status == 200) {
        console.log(arr);
        if (arr.result === "ok") {
          var SendrequestKind = [];
          for (var k = 0; k < arr.data.length; k++) {
            SendrequestKind.push({
              value: arr.data[k].sendrequest_kind_id,
              label: arr.data[k].sendrequest_kind_name,
            });
          }
          self.setState(
            {
              optionSendrequestKind: SendrequestKind,
              selectedSendrequestKind: SendrequestKind[0],
            },
            () => {}
          );
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
  };



// ------------------------------------------------------------------------------------------------------------
  async getoptionStateID ()  {
      //   post
    var self = this;
    const response = await $POST("statecity?command=get_state");
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          var State = [{ value: "0", label: "همه استانها" }];
          for (var k = 0; k < arr.data.length; k++) {
            State.push({
              value: arr.data[k].state_id,
              label: arr.data[k].state_name,
            });
          }
          self.setState({ optionState: State }, () => {
            //   self.getoptionCityID();
          });
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
  };



// ------------------------------------------------------------------------------------------
async  getoptionCityID() {
      // post
      var self = this;
      const response = await $POST(`statecity?command=get_city&state_id=${this.state.selectedState.value}`);
      const arr = response.data;
        if (response.status == 200) {
          if (arr.result === "ok") {
            var State = [{ value: "0", label: "همه شهر ها" }];
            for (var k = 0; k < arr.data.length; k++) {
              State.push({
                value: arr.data[k].city_id,
                label: arr.data[k].city_name,
              });
            }
            self.setState({ optionCity: State });
          } else if (arr.result === "error") {
            self.setState({
              snackstr: arr.desc,
              showSnack: true,
              snackMode: "error",
            });
          }
        }
    };

// ---------------------------------------------------------------------------------------------------------

 async saveNewKindsendrequest () {
    const {
      selectedCompany,
      selectedShift,
      selectedFieldinsurance,
      selectedSendrequestKind,
      selectedState,
      selectedCity,
      selectedAgent,
    } = this.state;

    if (
      selectedFieldinsurance.value == null ||
      selectedCompany.value == null ||
        selectedShift.value == null ||
      selectedState.value == null ||
      selectedCity.value == null ||
      selectedAgent.value == null
    ) {
      this.setState({
        snackstr: "لطفا پارامتر های فرم را کامل نمایید",
        showSnack: true,
        snackMode: "error",
      });
    } else {
      this.props.props.props.dispatch({
        type: "WAITSHOW",
      });

      var self = this;
      const response = await $POST(`kindsendrequest?command=add_kindsendrequest&kindsendrequest_company_id=${selectedCompany.value}&shift_id=${selectedShift.value}&
      kindsendrequest_fieldinsurance_id=${selectedFieldinsurance.value}&kindsendrequest_kind_id=${selectedSendrequestKind.value}&
      kindsendrequest_state_id=${selectedState.value}&kindsendrequest_city_id=${selectedCity.value}&
      kindsendrequest_agent_id=${selectedAgent.value}
      `);
      const arr = response.data;
        if (response.status == 200) {
          if (arr.result === "ok") {
            self.setState({
              snackstr: arr.desc,
              showSnack: true,
              snackMode: "success",
            });
            //self.setState({ redirect: true })
            self.getKindsendrequest();
            self.newKindsendrequestFunc();
          } else if (arr.result === "error") {
            self.setState({
              snackstr: arr.desc,
              showSnack: true,
              snackMode: "error",
            });
          }
          self.props.props.props.dispatch({
            type: "WITEHIDE",
          });
        }
        };
      }



// -------------------------------------------------------------------------------------------------------------
 async changeKindsendrequest () {
    const {
      kindsendrequest_id,
      selectedCompany,
      selectedShift,
      selectedFieldinsurance,
      selectedSendrequestKind,
      selectedState,
      selectedCity,
      selectedAgent,
    } = this.state;

    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });

    var self = this;
    const response = await $POST(`kindsendrequest?command=modify_kindsendrequest&kindsendrequest_id=${kindsendrequest_id}&
    kindsendrequest_company_id=${selectedCompany.value}&shift_id=${selectedShift.value}&kindsendrequest_fieldinsurance_id=${selectedFieldinsurance.value}&
    kindsendrequest_kind_id=${selectedSendrequestKind.value}&kindsendrequest_state_id=${selectedState.value}&
    kindsendrequest_city_id=${selectedCity.value}&kindsendrequest_agent_id=${selectedAgent.value}
    `);
    const arr = response.data;
      if (response.status == 200) {
        console.log(this.responseText);
        if (arr.result === "ok") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "success",
          });
          //self.setState({ redirect: true })
          self.getKindsendrequest();
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
  };
 }



// ------------------------------------------------------------------------------------------------------------------
async  deletKindsendrequest () {
    const { kindsendrequest_id } = this.state;
    this.props.props.props.dispatch({
      type: "WAITSHOW",
    });

    var self = this;
    const response = await $POST(`kindsendrequest?command=delete_kindsendrequest&kindsendrequest_id=${kindsendrequest_id}`);
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "success",
          });
          //self.setState({ redirect: true })
          self.getKindsendrequest();
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
        self.props.props.props.dispatch({
          type: "WITEHIDE",
        });
      }
  };




  createSortHandler = (field) => {
    if (this.state.orderBy === field) {
      if (this.state.order === "asc") {
        this.setState({ order: "desc" });
      } else {
        this.setState({ order: "asc" });
      }
    } else {
      this.setState({ orderBy: field, order: "asc" });
    }
    var arraytemp = [],
      i,
      j,
      temp,
      a,
      b;
    arraytemp = this.state.agentInfofilter;
    for (i = 0; i < arraytemp.length; i++) {
      for (j = 0; j < arraytemp.length - 1; j++) {
        a = arraytemp[j];
        b = arraytemp[j + 1];
        if (a[field] < b[field] && this.state.order === "asc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        } else if (a[field] > b[field] && this.state.order === "desc") {
          temp = arraytemp[j];
          arraytemp[j] = arraytemp[j + 1];
          arraytemp[j + 1] = temp;
        }
      }
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 });
  };

  handleAgent = (selectedAgent) => {
    this.setState({ selectedAgent: selectedAgent });
  };
  handleChangePage = (event, number) => {
    this.setState({ page: parseInt(number, 0) });
  };

  handleState = (selectedState) => {
    this.setState(
      {
        selectedState: selectedState,
        selectedCity: { value: "0", label: "همه شهرها" },
      },
      () => {
        this.getoptionCityID();
      }
    );
  };

  handleCity = (selectedCity) => {
    this.setState({ selectedCity: selectedCity }, () => {});
  };

  handleCompany = (selectedCompany) => {
    this.setState({ selectedCompany: selectedCompany }, () => {
      this.getoptionAgent();
    });
  };
  handleShift = (selectedShift) => {
    this.setState({ selectedShift: selectedShift }, () => {
    });
  };

  handleFieldinsurance = (selectedFieldinsurance) => {
    this.setState({ selectedFieldinsurance: selectedFieldinsurance }, () => {});
  };

  handleSendrequestKind = (selectedSendrequestKind) => {
    this.setState({ selectedSendrequestKind: selectedSendrequestKind });
  };
  onSelectOptionSendrequestKind = (selectedList, selectedItem) => {
    this.setState(
      {
        selectedFilterSendrequestKind: selectedList,
      },
      () => {}
    );
  };

  onRemoveOptionSendrequestKind = (selectedList, removedItem) => {
    this.setState(
      {
        selectedFilterSendrequestKind: selectedList,
      },
      () => {}
    );
  };

  onSelectOptionCompany = (selectedList, selectedItem) => {
    this.setState(
      {
        selectedFilterCompany: selectedList,
      },
      () => {}
    );
  };

  onRemoveOptionCompany = (selectedList, removedItem) => {
    this.setState(
      {
        selectedFilterCompany: selectedList,
      },
      () => {}
    );
  };

  onSelectOptionFieldinsurance = (selectedList, selectedItem) => {
    this.setState(
      {
        selectedFilterFieldinsurance: selectedList,
      },
      () => {}
    );
  };

  onRemoveOptionFieldinsurance = (selectedList, removedItem) => {
    this.setState(
      {
        selectedFilterFieldinsurance: selectedList,
      },
      () => {}
    );
  };

  onSelectOptionCity = (selectedList, selectedItem) => {
    this.setState(
      {
        selectedFilterCity: selectedList,
      },
      () => {}
    );
  };

  onRemoveOptionCity = (selectedList, removedItem) => {
    this.setState(
      {
        selectedFilterCity: selectedList,
      },
      () => {}
    );
  };
  onSelectOptionState = (selectedList, selectedItem) => {
    this.setState(
      {
        selectedFilterState: selectedList,
      },
      () => {
        this.getOptionFilterCity();
      }
    );
  };

  onRemoveOptionState = (selectedList, removedItem) => {
    this.setState(
      {
        selectedFilterState: selectedList,
      },
      () => {
        this.getOptionFilterCity();
      }
    );
  };
  getOptionFilterCity = () => {
    const { selectedFilterState, optionState } = this.state;
    this.setState({ optionFilterCity: [] }, () => {
      for (var i = 0; i < selectedFilterState.length; i++) {
        this.getCity(selectedFilterState[i].value);
      }
    });
  };
// -------------------------------------------------------------------------------------------------------
async getCity (state_id) {
    var self = this;
    const response = await $POST(`statecity?command=get_city&state_id=${state_id}`);
    const arr = response.data;
      if (response.status == 200) {
        if (arr.result === "ok") {
          var State;
          if (self.state.optionFilterCity.length > 0) {
            var State = self.state.optionFilterCity;
          } else {
            var State = [];
          }
          for (var k = 0; k < arr.data.length; k++) {
            State.push({
              value: arr.data[k].city_id,
              label: arr.data[k].city_name,
            });
          }
          self.setState({ optionFilterCity: State });
        } else if (arr.result === "error") {
          self.setState({
            snackstr: arr.desc,
            showSnack: true,
            snackMode: "error",
          });
        }
      }
  };





  filterFunc = () => {
    const {
      requestinfos,
      selectedFilterState,
      selectedFilterCity,
      selectedFilterCompany,
      selectedFilterFieldinsurance,
      selectedFilterSendrequestKind,
    } = this.state;


    // console.log('selectedFilterFieldinsurance',selectedFilterFieldinsurance)
    // console.log('requestinfos',requestinfos)

    const matchesFilter = (item, selectedArray, itemKey) => {
      if (!selectedArray || selectedArray.length === 0) return true;
      // تبدیل به رشته/عدد اگر لازم باشه:
      return selectedArray.some(opt => String(opt.value) === String(item[itemKey]));
    };

    const agentInfofilter = requestinfos.filter(item => {
      return (
          matchesFilter(item, selectedFilterState, 'kindsendrequest_state_id') &&
          matchesFilter(item, selectedFilterCity, 'kindsendrequest_city_id') &&
          matchesFilter(item, selectedFilterCompany, 'kindsendrequest_company_id') &&
          matchesFilter(item, selectedFilterFieldinsurance, 'kindsendrequest_fieldinsurance_id') &&
          matchesFilter(item, selectedFilterSendrequestKind, 'kindsendrequest_kind_id')
      );
    });

    this.setState({ agentInfofilter });
  };

  ClearFilter = () => {
    this.setState({
      selectedFilterCompany: [],
      selectedFilterFieldinsurance: [],
      selectedFilterSendrequestKind: [],
      selectedFilterState: [],
      selectedFilterCity: [],
      optionFilterCity: [],
      selectedOptionCity: [],
      selectedOptionState: [],
      agentInfofilter: this.state.requestinfos,
    });
    this.multiselectCompanyRef.current.resetSelectedValues();
    this.multiselectFieldinsuranceRef.current.resetSelectedValues();
    this.multiselectSendrequestKindRef.current.resetSelectedValues();
    this.multiselectStateRef.current.resetSelectedValues();
    this.multiselectCityRef.current.resetSelectedValues();
  };

  render() {
    const { classes } = this.props;
    const {
      selectedAgent,
      optionAgent,
      optionCity,
      optionFilterCity,
      selectedCity,
      optionCompany,
      optionShift,
      selectedCompany,
      selectedShift,
      optionFieldinsurance,
      selectedFieldinsurance,
      optionSendrequestKind,
      selectedSendrequestKind,
      optionState,
      selectedState,
      snackMode,
      snackstr,
      showSnack,
      newKindsendrequest,
      kindsendrequest_id,
      agent_company_logo_url,
      order,
      orderBy,
      okstatus,
      errstr,
      redirect,
      agentInfofilter,
      rowsPerPage,
      page,
    } = this.state;
    if (redirect) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className={classes.paperrtl} dir="ltr">
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            onClose={this.handleClickcloseTasckBar}
            open={showSnack}
            autoHideDuration={10000}
          >
            <Alert severity={snackMode}>{snackstr}</Alert>
          </Snackbar>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Container component="main" maxWidth="lg">
                <Paper elevation={4} className={classes.root}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Typography align="center" variant="h7">
                        {"آی دی روش توزیع : " + kindsendrequest_id}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}></Grid>

                    <Grid item xs={6}>
                      <div>
                        <label className="on">استان</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"استان"}
                          value={selectedState}
                          onChange={this.handleState}
                          options={optionState}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div>
                        <label className="on">شهر</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"شهر"}
                          value={selectedCity}
                          onChange={this.handleCity}
                          options={optionCity}
                        />
                      </div>
                    </Grid>


                    <Grid item xs={4}>
                      <div>
                        <label className="on">شرکت بیمه</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"شرکت بیمه"}
                          value={selectedCompany}
                          onChange={this.handleCompany}
                          options={optionCompany}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <img
                          alt="Remy Sharp"
                          style={{ width: "25%" }}
                          src={selectedCompany.logo}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={4}>
                      <div>
                        <label className="on">رشته بیمه</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"رشته بیمه"}
                          value={selectedFieldinsurance}
                          onChange={this.handleFieldinsurance}
                          options={optionFieldinsurance}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <img
                          alt="Remy Sharp"
                          style={{ width: "25%" }}
                          src={selectedFieldinsurance.logo}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div>
                        <label className="on">نوع توزیع </label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={" نوع توزیع"}
                          value={selectedSendrequestKind}
                          onChange={this.handleSendrequestKind}
                          options={optionSendrequestKind}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div>
                        <label className="on">نماینده</label>
                        <Select
                          isSearchable={true}
                          className="adapter-txtsize"
                          placeholder={"نماینده"}
                          value={selectedAgent}
                          onChange={this.handleAgent}
                          options={optionAgent}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <label className="on">شیفت ها</label>
                        <Select
                            isSearchable={true}
                            className="adapter-txtsize"
                            placeholder={"شیفت ها"}
                            value={selectedShift}
                            onChange={this.handleShift}
                            options={optionShift}
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      {newKindsendrequest ? (
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={(e) => {
                            this.saveNewKindsendrequest();
                          }}
                        >
                          {"ثبت روش توزیع جدید "}
                        </Button>
                      ) : (
                        <div style={{ width: "100%", textAlign: "right" }}>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={this.newKindsendrequestFunc}
                          >
                            {"روش توزیع جدید"}
                          </Button>
                          {"          "}
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={(e) => {
                              this.changeKindsendrequest();
                            }}
                          >
                            {"ثبت تغییرات"}
                          </Button>
                          {"          "}
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={(e) => {
                              this.deletKindsendrequest();
                            }}
                          >
                            {"حذف روش"}
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
            </Grid>

            <Grid item xs={12}>
              <Container component="main" maxWidth="lg">
                <Paper elevation={4} className={classes.root}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={optionCompany} // Options to display in the dropdown
                          //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                          onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                          ref={this.multiselectCompanyRef}
                          displayValue="label" // Property name to display in the dropdown options
                          placeholder="شرکت بیمه"
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={optionFieldinsurance} // Options to display in the dropdown
                          //selectedValues={selectedOptionFieldinsurance} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionFieldinsurance} // Function will trigger on select event
                          onRemove={this.onRemoveOptionFieldinsurance} // Function will trigger on remove event
                          ref={this.multiselectFieldinsuranceRef}
                          displayValue="label" // Property name to display in the dropdown options
                          placeholder="رشته بیمه"
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={optionSendrequestKind} // Options to display in the dropdown
                          //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionSendrequestKind} // Function will trigger on select event
                          onRemove={this.onRemoveOptionSendrequestKind} // Function will trigger on remove event
                          ref={this.multiselectSendrequestKindRef}
                          displayValue="label" // Property name to display in the dropdown options
                          placeholder="نوع توزیع"
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={optionState} // Options to display in the dropdown
                          //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionState} // Function will trigger on select event
                          onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                          ref={this.multiselectStateRef}
                          displayValue="label" // Property name to display in the dropdown options
                          placeholder="استان ها "
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={6}>
                      <div style={{ width: "100%", textAlign: "center" }}>
                        <Multiselect
                          style={styleselect}
                          options={optionFilterCity} // Options to display in the dropdown
                          //selectedValues={selectedOptionCity} // Preselected value to persist in dropdown
                          onSelect={this.onSelectOptionCity} // Function will trigger on select event
                          onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                          ref={this.multiselectCityRef}
                          displayValue="label" // Property name to display in the dropdown options
                          placeholder="شهر ها "
                          closeIcon="circle2"
                          emptyRecordMsg="فیلد  در دسترس نیست "
                        />
                      </div>
                    </Grid>

                    <Grid item xs={3}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.filterFunc}
                      >
                        {"جستجو "}
                      </Button>
                    </Grid>
                    <Grid item xs={3}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.ClearFilter}
                      >
                        {"پاک کردن فیلتر ها "}
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
            </Grid>

            <Grid item xs={12}>
              {console.log('agentInfofilter',agentInfofilter)}
              <Container maxWidth="lg">
                <Paper className={classes.root}>
                  <TableContainer dir="rtl">
                    <Table aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <ExcelFile
                              element={
                                <Button variant="outlined" color="primary">
                                  {" "}
                                  {"اکسل "}
                                </Button>
                              }
                            >
                              <ExcelSheet
                                data={agentInfofilter}
                                name="نمایندگان"
                              >
                                <ExcelColumn
                                  label="آی دی"
                                  value="kindsendrequest_id"
                                />
                                <ExcelColumn
                                  label="استان "
                                  value="agent_state_name"
                                />
                                <ExcelColumn
                                  label="شهر "
                                  value="agent_city_name"
                                />
                                <ExcelColumn
                                    label="شرکت بیمه"
                                    value={(row) => row.company_name || "همه شرکت‌ها"}
                                />
                                <ExcelColumn
                                  label="رشته بیمه"
                                  value="fieldinsurance_name"
                                />
                                <ExcelColumn
                                  label="نوع توزیع"
                                  value="sendrequest_kind_name"
                                />
                                <ExcelColumn
                                  label="جنسیت"
                                  value="agent_gender"
                                />
                                <ExcelColumn label="نام" value="agent_name" />
                                <ExcelColumn
                                  label="نام خانوادگی"
                                  value="agent_family"
                                />
                                <ExcelColumn
                                  label="شماره همراه"
                                  value="agent_mobile"
                                />
                                <ExcelColumn
                                  label="کد نمایندگی"
                                  value="agent_code"
                                />
                                <ExcelColumn
                                    label="عنوان شیفت"
                                    value="shift_name"
                                />
                              </ExcelSheet>
                            </ExcelFile>
                          </TableCell>

                          <TableCell
                            key={"agent_state_name"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"استان"}
                            <TableSortLabel
                              active={orderBy === "agent_state_name"}
                              direction={
                                orderBy === "agent_state_name" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_state_name");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"agent_city_name"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"شهر"}
                            <TableSortLabel
                              active={orderBy === "agent_city_name"}
                              direction={
                                orderBy === "agent_city_name" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_city_name");
                              }}
                            ></TableSortLabel>
                          </TableCell>
                          <TableCell
                            key={"agent_company_name"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"شرکت بیمه"}
                            <TableSortLabel
                              active={orderBy === "agent_company_name"}
                              direction={
                                orderBy === "agent_company_name" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_company_name");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"fieldinsurance_name"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"رشته بیمه"}
                            <TableSortLabel
                              active={orderBy === "fieldinsurance_name"}
                              direction={
                                orderBy === "fieldinsurance_name"
                                  ? order
                                  : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("fieldinsurance_name");
                              }}
                            ></TableSortLabel>
                          </TableCell>
                          <TableCell
                            key={"kindsendrequest_kind_id"}
                            align={"center"}
                            style={{ minWidth: 20 }}
                            sortDirection={
                              orderBy === "kindsendrequest_kind_id"
                                ? order
                                : false
                            }
                          >
                            {"نوع ارجاع"}
                            <TableSortLabel
                              active={orderBy === "kindsendrequest_kind_id"}
                              direction={
                                orderBy === "kindsendrequest_kind_id"
                                  ? order
                                  : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler(
                                  "kindsendrequest_kind_id"
                                );
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"agent_name"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {"نام و نام خانوادگی "}
                            <TableSortLabel
                              active={orderBy === "agent_name"}
                              direction={
                                orderBy === "agent_name" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_name");
                              }}
                            ></TableSortLabel>
                          </TableCell>

                          <TableCell
                            key={"agent_mobile"}
                            align={"center"}
                            style={{ minWidth: 60 }}
                          >
                            {" شماره همراه "}
                            <TableSortLabel
                              active={orderBy === "agent_mobile"}
                              direction={
                                orderBy === "agent_mobile" ? order : "asc"
                              }
                              onClick={(e) => {
                                this.createSortHandler("agent_mobile");
                              }}
                            ></TableSortLabel>
                          </TableCell>
                          <TableCell
                              key={"shift_name"}
                              align={"center"}
                              style={{ minWidth: 60 }}
                          >
                            {"عنوان شیفت "}
                            <TableSortLabel
                                active={orderBy === "shift_name"}
                                direction={
                                  orderBy === "shift_name" ? order : "asc"
                                }
                                onClick={(e) => {
                                  this.createSortHandler("shift_name");
                                }}
                            ></TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {agentInfofilter
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => {
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={row["kindsendrequest_id"]}
                                value={row}
                                onClick={() => {
                                  this.handleSelectRows(row);
                                }}
                              >
                                <TableCell
                                  key={"kindsendrequest_id"}
                                  align={"center"}
                                >
                                  {row["kindsendrequest_id"]}
                                </TableCell>

                                <TableCell
                                  key={"agent_state_name"}
                                  align={"center"}
                                >
                                  {row["agent_state_name"]}
                                </TableCell>

                                <TableCell
                                  key={"agent_city_name"}
                                  align={"center"}
                                >
                                  {row["agent_city_name"]}
                                </TableCell>

                                <TableCell
                                    key={"agent_company_name"}
                                    align={"center"}
                                >
                                  {!row["agent_company_name"] || row["agent_company_name"].trim() === ""
                                      ? "همه شرکت‌ها"
                                      : row["agent_company_name"]}
                                </TableCell>


                                <TableCell
                                  key={"fieldinsurance_name"}
                                  align={"center"}
                                >
                                  {row["fieldinsurance_name"]}
                                </TableCell>

                                <TableCell
                                  key={"sendrequest_kind_name"}
                                  align={"center"}
                                >
                                  {row["sendrequest_kind_name"]}
                                </TableCell>

                                <TableCell key={"agent_name"} align={"center"}>
                                  {row["agent_name"] +
                                    " " +
                                    row["agent_family"]}
                                </TableCell>

                                <TableCell
                                  key={"agent_mobile"}
                                  align={"center"}
                                >
                                  {row["agent_mobile"]}
                                </TableCell>
                                <TableCell
                                    key={"shift_name"}
                                    align={"center"}
                                >
                                  {row["shift_name"]}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={agentInfofilter.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </Paper>
              </Container>
            </Grid>
          </Grid>

          {okstatus ? (
            <Alert severity="success">
              <AlertTitle>پیام</AlertTitle>
              {errstr}
            </Alert>
          ) : null}
        </div>
      );
    }
  }
}

export default withStyles(styles)(ChangeKindsendrequest);
